import { faCheck, faClose, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Button, Card, Col, Stack } from "react-bootstrap";
import { deleteFieldChoice, patchFieldChoice } from "../../../services/httpClient";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import IconButton from "../../ui/IconButton";

interface CardState {
  noteTypeId: any;
  fieldId: any;
  item: any;
  getItems: any;
  getNotes: any;
  archived: boolean | number | null | undefined;
  published: boolean | number | null | undefined;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const FieldChoiceCard = ({
  noteTypeId,
  fieldId,
  item,
  getItems,
  getNotes,
  archived,
  published,
  setOrgToSave,
  setErrMessage,
  setShowToast,
  setToastText,
  setToastBody,
}: CardState) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [itemName, setItemName] = useState<string>(item?.name);

  const onClickEdit = () => {
    setIsEditing(true);
  };

  const onClickEditFinal = () => {
    const updatedChoice = {
      name: itemName,
    };

    patchFieldChoice(updatedChoice, noteTypeId, fieldId, item?.id)
      .then((res: any) => {
        unsavedChanges.value = false;
        setOrgToSave(false);
        setShowToast(true);
        setToastText("Note Type Field Choice Updated");
        setToastBody(itemName);
        setIsEditing(false);
        getItems();
      })
      .catch((err: any) => {
        setIsEditing(false);
        setErrMessage(err?.response?.data?.msg);
        setItemName(item?.name);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelEdit = () => {
    unsavedChanges.value = false;
    setOrgToSave(false);
    setIsEditing(false);
    setErrMessage(undefined);
  };

  const onUpdateName = (e: any) => {
    setItemName(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
    setErrMessage(undefined);
  };

  const onClickDelete = () => {
    setIsDeleting(true);
  };

  const onClickDeleteFinal = () => {
    deleteFieldChoice(noteTypeId, fieldId, item?.id)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Note Type Field Choice Deleted");
        setToastBody(itemName);
        setIsDeleting(false);
      })
      .catch((err: any) => {
        setIsDeleting(false);
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      })
      .finally(() => {
        getItems();
        getNotes();
      });
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
    setErrMessage(undefined);
  };

  const renderEdit = () => {
    return (
      <Card key={item.name} className="bg-light mb-2">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Col>
              <Input label="Name" type="text" value={itemName} onUpdate={(e: any) => onUpdateName(e)} />
            </Col>
            <FontAwesomeIcon className="text-muted me-1 cursor-pointer" icon={faCheck} onClick={() => onClickEditFinal()} />
            <div className="vr" />
            <FontAwesomeIcon className="text-muted me-1 cursor-pointer" icon={faClose} onClick={() => onClickCancelEdit()} />
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  const renderDelete = () => {
    return (
      <Card key={item.name} className="bg-light mb-2">
        <Card.Body>
          <Stack direction="horizontal" gap={3}>
            <Stack style={{ justifyContent: "center" }} gap={2}>
              <Card.Subtitle>Remove {item?.name}?</Card.Subtitle>
            </Stack>
            <Button className="app-danger-color button" onClick={() => onClickDeleteFinal()}>
              Confirm Delete
            </Button>
            <div className="vr" />
            <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
              Cancel
            </Button>
          </Stack>
        </Card.Body>
      </Card>
    );
  };

  return (
    <>
      {isEditing ? (
        <>{renderEdit()}</>
      ) : isDeleting ? (
        <>{renderDelete()}</>
      ) : (
        <Card key={item.name} className="mb-2">
          <Card.Body>
            <Stack direction="horizontal" gap={3}>
              <Stack gap={2} className="align-self-center">
                <Card.Subtitle className="text-muted">
                  <small>{item.name}</small>
                </Card.Subtitle>
              </Stack>
              {!archived && (
                <>
                  <IconButton onClickButton={onClickEdit} tooltipText={"Edit"} icon={faEdit} />
                  {!published && (
                    <>
                      <div className="vr" />
                      <IconButton onClickButton={onClickDelete} tooltipText={"Delete"} icon={faTrash} />
                    </>
                  )}
                </>
              )}
            </Stack>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default FieldChoiceCard;
